exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".WishLists-createIcon-1JAcO{\r\n    width: 16px;\r\n}\r\n.WishLists-flexColumn-3WRLF{\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-wrap: wrap;\r\n        flex-wrap: wrap;\r\n}", ""]);

// exports
exports.locals = {
	"createIcon": "WishLists-createIcon-1JAcO",
	"flexColumn": "WishLists-flexColumn-3WRLF"
};